<template>
  <div
    style="min-width:1200px;"
    class="big"
  >
    <ImportData
      :isFlag="importdata"
      @refreshList="getList"
    ></ImportData>
    <div class="page_title">用户拉新任务管理（业务员）
      <el-button
        type="primary"
        size="medium"
        @click="getExplain"
        :disabled="
          module_id_array[0] ? !module_id_array.includes('944') : false
        "
      >指标说明</el-button>
    </div>
    <div style="padding:20px;">
      <div class="container">
        <div class="searchbox">
          <div class="item">
            <span>任务周</span>
            <el-date-picker
              v-model="date"
              type="week"
              format="yyyy 第 WW 周"
              value-format="yyyy-MM-dd"
              :clearable="false"
              :picker-options="pickerOptions"
              @change="(value)=>{return changeWeek(value,1)}"
              style="width: 160px; margin-left: 6px"
            >
            </el-date-picker>
          </div>
          <div class="item">
            <span>员工号</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_code"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工姓名</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_name"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
          </div>
          <div class="item">
            <span>员工手机号</span>
            <el-input
              placeholder="请输入"
              v-model="recommender_phone"
              style="width: 140px; margin-left: 6px"
              clearable
              @change="search"
            ></el-input>
            <el-button
              type="info"
              style="background-color: #eceff2; color: #747981; margin-left: 6px"
              @click="search"
            >查询</el-button>
            <span style="margin: 0 10px 0 15px">是否达标</span>
            <el-radio-group
              v-model="is_stand"
              @change="search"
            >
              <el-radio :label="0">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="2">否</el-radio>
            </el-radio-group>
          </div>
        </div>
        <div class="pricebox">
          <div class="price">
            <div class="priceitem">
              <div style="padding-right:20px;font-size:20px">{{ weekData }}</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ user_num }}</div>
              <div class="gray">员工人数</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ task_num }}</div>
              <div class="gray">总任务人数</div>
            </div>
            <div class="priceitem">
              <div class="num">{{ auth_num }}</div>
              <div class="gray">达标数</div>
            </div>
          </div>
          <span>
            <el-button
              type="primary"
              @click="addData"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('934') : false
        "
            >导入任务</el-button>
            <el-button
              @click="deldata=true;del_month=''"
              :disabled="
          module_id_array[0] ? !module_id_array.includes('933') : false
        "
            >删除任务</el-button>
          </span>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column
              label="员工号"
              prop="recommender_code"
            >
            </el-table-column>

            <el-table-column
              label="员工姓名"
              prop="recommender_name"
            >
            </el-table-column>
            <el-table-column
              label="员工手机号"
              prop="phone"
            ></el-table-column>
            <el-table-column
              label="任务人数"
              prop="user_num"
            ></el-table-column>
            <el-table-column
              label="本周注册用户数"
              prop="user_count"
            ></el-table-column>
            <el-table-column
              label="本周达标用户数"
              prop="auth_count"
            ></el-table-column>
            <el-table-column label="本周是否达标">
              <template slot-scope="scope">

                <div v-if="scope.row.auth_count>=scope.row.user_num">是</div>
                <div v-else>否</div>
              </template>

            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  @click="toDetail(scope.row.recommender_code)"
                  :disabled="
                module_id_array[0] ? !module_id_array.includes('935') : false
              "
                >详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div style="padding: 20px 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      title="请选择删除任务周"
      :visible.sync="deldata"
      width="360px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div style="padding:30px 40px">
        <div>
          <span>任务周</span>
          <el-date-picker
            v-model="del_date"
            type="week"
            format="yyyy 第 WW 周"
            value-format="yyyy-MM-dd"
            placeholder="选择周"
            :clearable="false"
            :picker-options="pickerOptions"
            @change="(value)=>{return changeWeek(value,0)}"
            style="width: 200px; margin-left: 10px"
          >
          </el-date-picker>
        </div>
        <div style="text-align:center;margin-top:40px">
          <el-button
            type="primary"
            size="mini"
            @click="delWeek"
          >确认</el-button>
          <el-button
            plain
            size="mini"
            @click="deldata=false"
          >取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 指标说明编辑 -->
    <el-dialog
      title="指标说明编辑"
      :visible.sync="explainDia"
      width="600px"
      style="text-align: left"
      :close-on-click-modal="false"
    >
      <div style="padding:20px 30px">
        <div style="width:100%;height:100%;">
          <wangeditor ref="editorBox" />
        </div>
        <div style="text-align:center;margin-top:40px">
          <el-button
            type="primary"
            size="medium"
            @click="saveExplain"
            :disabled="
          module_id_array[0] ? !module_id_array.includes('945') : false
        "
          >保存</el-button>
          <el-button
            plain
            size="medium"
            @click="explainDia=false"
          >取消</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs';
import wangeditor from './wangeditor';
import ImportData from './ImportData.vue';
export default {
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      date: '',
      recommender_phone: '',
      recommender_code: '',
      recommender_name: '',
      week: '',
      is_stand: 0,
      importdata: false,
      deldata: false,
      del_month: '',
      user_num: 0,
      task_num: 0,
      auth_num: 0,
      pickerOptions: {
        firstDayOfWeek: 1
      },
      weekData: '',
      del_date: '',
      del_week: '',
      explainDia: false
    };
  },
  components: {
    ImportData,
    wangeditor
  },
  filters: {
    dateFormat(date) {
      return dayjs.unix(date).format('YYYY-MM');
    }
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  methods: {
    //获取列表
    getList() {
      if (!this.week) {
        this.$message.error('请选择任务周');
        return false;
      }
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        week: this.week,
        recommender_phone: this.recommender_phone,
        recommender_code: this.recommender_code,
        recommender_name: this.recommender_name,
        is_stand: this.is_stand
      };
      this.axios
        .post('platform/Activity/getRecommenderWeekUserList', data)
        .then((res) => {
          if (res.code == 0) {
            if (!res.data.list.length && this.currentPage > 1) {
              this.currentPage = this.currentPage - 1;
              this.getList();
            }
            this.tableData = res.data.list;
            this.user_num = res.data.user_num; //员工人数
            this.task_num = res.data.task_num; //总任务数
            this.auth_num = res.data.auth_num; //达标数
            this.totalNum = res.data.total;
          }
        });
    },
    //查看详情
    toDetail(recommender_code) {
      this.$router.push({
        path: 'usersalesmandetail',
        query: {
          recommender_code,
          date: this.date
        }
      });
    },
    //改变周
    changeWeek(value, type) {
      let now = new Date(value);
      let now_day = now.getDay();
      if (now_day == 0) {
        now_day = 7;
      }
      let now_time = now.getTime();
      let monDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (1 - now_day))
      ).format('MM-DD');
      let sunDay = dayjs(
        new Date(now_time + 24 * 60 * 60 * 1000 * (7 - now_day))
      ).format('MM-DD');

      let d1 = new Date(value);
      let d2 = new Date(value);
      d2.setMonth(0);
      d2.setDate(1);
      let rq = d1 - d2;
      let days = Math.ceil(rq / (24 * 60 * 60 * 1000));
      let num = Math.ceil(days / 7);
      let year = dayjs(value).year();

      if (type) {
        this.weekData = year + '第' + num + '周 ' + monDay + '~' + sunDay;
        this.week = year + '-' + monDay + '~' + year + '-' + sunDay;
        this.getList();
      } else {
        this.del_week = year + '-' + monDay + '~' + year + '-' + sunDay;
        this.changeDelWeek();
      }
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导入数据
    addData() {
      this.importdata = !this.importdata;
    },
    //删除改变周
    changeDelWeek() {
      let week = this.del_week;
      this.axios
        .post('platform/Activity/recommenderWeekUserCount', { week })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.info.count == 0) {
              this.$alert('该周任务不存在,请重新选择', '提示', {
                confirmButtonText: '确定',
                callback: (action) => {
                  this.del_week = '';
                  this.del_date = '';
                }
              });
            }
          }
        });
    },
    delWeek() {
      if (!this.del_week) {
        this.$message.error('请选择删除的任务周');
        return false;
      }
      let week = this.del_week;
      this.axios
        .post('platform/Activity/delRecommenderWeekUser', { week })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('删除成功');
            this.deldata = false;
            this.getList();
          }
        });
    },
    //获取指标说明
    getExplain() {
      let type = 24;
      this.axios
        .post('platform/Activity/getIndicatorDescription', { type })
        .then((res) => {
          if (res.code == 0) {
            this.explainDia = true;
            setTimeout(() => {
              this.$refs.editorBox.editor.txt.html(res.data.info.content);
            }, 100);
          }
        });
    },
    //保存说明
    saveExplain() {
      let content = this.$refs.editorBox.editor.txt.html();
      if (!content) {
        this.$message.error('请填写内容');
        return false;
      }
      let data = {
        content: content,
        type: 24
      };
      this.axios
        .post('platform/Activity/editIndicatorDescription', data)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success('保存成功');
            this.explainDia = false;
          }
        });
    }
  },
  activated() {
    this.changeWeek(new Date(), 1);
    this.date = dayjs(new Date()).format('YYYY-MM-DD');
  }
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
  align-items: center;
  box-sizing: border-box;
  .item {
    margin-right: 14px;
  }
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin-bottom: 12px;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      min-width: 200px;
      border-right: solid 1px #e1e3e9;
    }
    .priceitem:before {
      content: '';
    }
  }
  .gray {
    font-size: 12px;
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 600;
    color: #f24e33;
  }
}
</style>
